export const isNumber = (value) => /^\d+$/.test(value);

export const isRealNumber = (value) => /^-?\d+(\.\d+)?$/.test(value);
